import * as React from "react";
import "./reconciliationModal.scss"
import Transaction from "../../../../../model/transaction/Transaction";
import Modal from "../../../../ui/modal/Modal";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import InvoiceSelectionComponent from "./selectInvoice/InvoiceSelectionComponent";
import {none, option, Option} from "ts-option";
import InvoiceSummary from "../../../../../model/invoice/InvoiceSummary";
import {api} from "../../../../../api/api";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";
import {ReconciliationSuccess} from "./ReconciliationSuccess";
import {Recommendations} from "./Recommendations";
import InvoicePaymentSummary from "../../../../../model/invoice/InvoicePaymentSummary";
import {withRouter} from "react-router-dom";
import {connect, Dispatch} from "react-redux";
import {fetchInvoice} from "../../../../../store/action/invoice/invoice";
import {getInvoiceById} from "../../../../../store/view/invoice";
import {RouteComponentProps} from "react-router";
import Routes from "../../../../../navigation/route/Route";
import Toast from "../../../../helper/Toast";
import {PaymentDetails} from "./PaymentDetails";
import {InvoiceInfo} from "./InvoiceInfo";
import {AmountToReconcile} from "./AmountToReconcile";
import {InvoicePaymentSummariesTable} from "./InvoicePaymentSummariesTable";
import {ConfirmReconcilePopup} from "./ConfirmReconcilePopup";
import {SelectedSummaryInfo} from "./SelectedSummaryInfo";
import {ReconciliationModalNavigation} from "./ReconciliationModalNavigation";
import classNames = require("classnames");

interface IProps {
	/**
	 * Transaction to be reconciled.
	 */
	transaction: Transaction;
	/**
	 * On close callback
	 */
	onClose: () => void;
	/**
	 * Successful reconciliation callback
	 */
	onReconciliationSuccess: () => void;
	/**
	 * Read only indicator.
	 */
	readOnly?: boolean;
	/**
	 * If true, internal navigation between transactions is visible.
	 */
	showNavigation?: boolean;
	/**
	 * Left navigation button click callback.
	 */
	onNavigateLeft?: () => void;
	/**
	 * Right navigation button click callback.
	 */
	onNavigateRight?: () => void;
	/**
	 * If true, left navigation button is disabled.
	 */
	navigateLeftDisabled?: boolean;
	/**
	 * If true, right navigation button is disabled.
	 */
	navigateRightDisabled?: boolean;
	/**
	 * Text to be rendered next to navigation buttons.
	 */
	navigationLabel?: string;
}

interface DispatchProps {
	/**
	 * Fetch invoice action.
	 * @param {string} jobId job identifier.
	 */
	fetchInvoice: (jobId: string) => void;
}

interface IState {
	/**
	 * Invoice selected for reconciliation.
	 */
	selectedInvoice: Option<InvoiceSummary>;
	/**
	 * Invoices recommended to be reconciliationStatus with transaction from props.
	 */
	recommendedInvoices: InvoiceSummary[];
	/**
	 * Index of shown recommended invoice.
	 */
	recommendedInvoiceIndex: number;
	/**
	 * Indicates if recommended invoices are shown.
	 */
	showRecommended: boolean;
	/**
	 * If true, show reconciliation success info.
	 */
	reconciliationSuccess: boolean;
	/**
	 * Invoice payments summary data.
	 */
	invoicePaymentSummaries: InvoicePaymentSummary[];
	/**
	 * Summary selected to be displayed.
	 */
	selectedSummary: Option<InvoicePaymentSummary>;
	/**
	 * If true, confirm undo reconciliation popup is displayed.
	 */
	showUndoReconciliationConfirm: boolean;
	/**
	 * Indicating if request to server is in progress.
	 */
	isLoading: boolean;
}

type Props = IProps & DispatchProps & RouteComponentProps<{}>;

class ReconciliationModal extends React.Component<Props, IState> {

	renderTableNoDataInfo =
		<tr className="c-reconciliation-modal_matched-invoices-table-container_no-data-row">
			<td colSpan={4}>
				<div className="c-reconciliation-modal_matched-invoices-table-container_no-data-row_content">
					Matched invoice(s) will be shown here.
				</div>
			</td>
		</tr>;

	constructor(props: Props) {
		super(props);
		this.state = {
			selectedInvoice: none,
			recommendedInvoices: [],
			showRecommended: true,
			recommendedInvoiceIndex: 0,
			reconciliationSuccess: props.readOnly,
			invoicePaymentSummaries: [],
			selectedSummary: none,
			showUndoReconciliationConfirm: false,
			isLoading: false
		};
		this.renderInvoiceMatchComponent = this.renderInvoiceMatchComponent.bind(this);
	}

	componentDidMount() {
		this.fetchRecommendations();
		this.fetchInvoicePaymentSummmaries();
	}

	fetchRecommendations = () => api.instance.transactionApi.fetchInvoiceRecommendationsForTransaction(this.props.transaction.id)
		.then(recommendedInvoices => {
			const showRecommended = !!recommendedInvoices.length;
			this.setState({recommendedInvoices, showRecommended});
		})
		.catch(error => notifyBugsnagAndShowToast(error, "Error fetching recommended invoices"));

	render() {
		const classFromProps = classNames({
			"c-reconciliation-modal_invoice-container": true,
			"readonly": this.props.readOnly && this.state.selectedSummary.isEmpty
		});
		const transaction = this.props.transaction;
		const modalLabel = this.props.readOnly ? "Reconciliation Details" : "Reconcile payment to Invoice";
		return (
			<Modal onCloseClicked={this.props.onClose} title={modalLabel} autoWidth={true}
				   customClass="c-reconciliation-modal">
				<div className="c-reconciliation-modal_content-container">
					<PaymentDetails transaction={transaction}
									showMatchRemainingAmount={!this.props.readOnly && this.state.selectedSummary.isDefined}
									onMatchRemainingAmountClick={this.onMatchRemainingAmountClick}/>
					<div className={classFromProps}>{this.renderInvoiceMatchComponent()}</div>
					{(!this.state.reconciliationSuccess || this.state.showUndoReconciliationConfirm) && !this.state.isLoading &&
					this.renderReconcilePopup()}
				</div>
				<InvoicePaymentSummariesTable invoicePaymentSummaries={this.state.invoicePaymentSummaries}
											  selectedSummaryId={this.state.selectedSummary.map(s => s.id)}
											  onSummarySelect={this.onSummarySelect}/>
				<AmountToReconcile due={this.props.transaction.due}/>
				<div className="c-reconciliation-modal_navigation-container">
					<div className="c-reconciliation-modal_navigation-container_navigator">
						{/*TODO: to be handled in workspace */}
						<ReconciliationModalNavigation visible={this.props.showNavigation}
													   navigateLeftDisabled={this.props.navigateLeftDisabled}
													   navigateRightDisabled={this.props.navigateRightDisabled}
													   onNavigateLeft={this.onNavigateLeft}
													   onNavigateRight={this.onNavigateRight}
													   navigationLabel={this.props.navigationLabel}/>
					</div>
					<div className="c-reconciliation-modal_navigation-container_button">
						<ButtonPrimary label={"Done"} onClick={this.props.onClose}/>
					</div>
				</div>
			</Modal>
		);
	}

	onMatchRemainingAmountClick = () => this.setState({
		reconciliationSuccess: false,
		selectedSummary: none,
		selectedInvoice: none,
		showUndoReconciliationConfirm: false,
		showRecommended: true
	});

	onSummarySelect = (summary: InvoicePaymentSummary) => this.setState({
		selectedSummary: option(summary),
		selectedInvoice: none,
		showUndoReconciliationConfirm: false,
		showRecommended: false
	});

	onNavigateLeft = () => this.setState({selectedSummary: none}, this.props.onNavigateLeft);

	onNavigateRight = () => this.setState({selectedSummary: none}, this.props.onNavigateRight);

	redirectToInvoice = () => this.state.selectedInvoice.map(inv =>
		this.props.history.push(Routes.InvoiceDetailsView(inv.referenceNumber)));

	renderInvoiceMatchComponent() {
		const renderRecommendations = this.state.showRecommended && this.state.recommendedInvoices.length;
		if (this.state.selectedSummary.isDefined) {
			return (
				<SelectedSummaryInfo>
					{this.state.selectedSummary.map(this.renderInvoiceInfo).orNull}
				</SelectedSummaryInfo>
			);
		}
		if (this.state.reconciliationSuccess) {
			return (
				<ReconciliationSuccess due={this.props.transaction.due}
									   referenceNumber={this.state.selectedInvoice.map(
										   inv => inv.invoiceNo.getOrElse(inv.referenceNumber))}
									   onMatchRemainingAmount={() => this.setState(
										   {reconciliationSuccess: false, selectedInvoice: none}, this.fetchRecommendations)}
									   readOnly={this.props.readOnly}
									   onReferenceNumberClick={this.redirectToInvoice}
									   onUndoReconciliationClick={() => this.setState({showUndoReconciliationConfirm: true})}/>
			);
		}
		if (renderRecommendations) {
			return (
				<Recommendations recommendationsLength={this.state.recommendedInvoices.length}
								 onPreviousRecommendationClick={() => this.setState(
									 {recommendedInvoiceIndex: this.state.recommendedInvoiceIndex - 1})}
								 onNextRecommendationClick={() => this.setState(
									 {recommendedInvoiceIndex: this.state.recommendedInvoiceIndex + 1})}
								 recommendationIndex={this.state.recommendedInvoiceIndex}>
					{this.renderInvoiceInfo(this.state.recommendedInvoices[this.state.recommendedInvoiceIndex])}
				</Recommendations>
			);
		}
		return (
			<>
				<div className="c-reconciliation-modal_details-title">Match invoice</div>
				{this.state.selectedInvoice.map(this.renderInvoiceInfo).getOrElse(() =>
					<>
						<InvoiceSelectionComponent
							onSelect={(invoice) => this.setState({selectedInvoice: option(invoice)})}/>
						<div className="c-reconciliation-modal_details-subtitle">Find the correct invoice for the
							transaction on the left.
						</div>
					</>)}
			</>
		);
	}

	renderInvoiceInfo = (invoice: InvoiceSummary | InvoicePaymentSummary) => {
		return (
			<InvoiceInfo invoice={invoice}
						 showUndoReconciliation={this.state.selectedSummary.map(s => s.canUndoReconciliation).getOrElse(false)}
						 onUndoReconciliationClick={() => this.setState({showUndoReconciliationConfirm: true})}/>
		);
	};

	renderReconcilePopup = () => {
		let invoiceToReconcile: Option<InvoiceSummary>;
		let question: string = "Is this the right invoice for the transaction?";
		let noOptionLabel: string;
		let noOptionCallback: () => void;
		let yesOptionLabel: string = "Yes, reconcile transaction";
		let yesOptionCallback: () => void = () => this.onReconcile(invoiceToReconcile);
		if (this.state.showUndoReconciliationConfirm) {
			const invoiceId: Option<string> = this.state.selectedSummary.map(s => option(s.invoiceId)).getOrElse(
				this.state.selectedInvoice.map(i => i.id));
			question = "Are you sure you want to unreconcile?";
			noOptionLabel = "Cancel";
			noOptionCallback = () => this.setState({showUndoReconciliationConfirm: false});
			yesOptionLabel = "Yes, unreconcile this invoice";
			yesOptionCallback = () => invoiceId.map(this.onUndoReconciliation);
		}
		else if (this.state.showRecommended && this.state.recommendedInvoices.length) {
			invoiceToReconcile = option(this.state.recommendedInvoices[this.state.recommendedInvoiceIndex]);
			noOptionLabel = "No, search manually";
			noOptionCallback = () => this.setState({showRecommended: false});
		}
		else if (this.state.selectedInvoice.isDefined) {
			invoiceToReconcile = this.state.selectedInvoice;
			noOptionLabel = "No, search again";
			noOptionCallback = () => this.setState({selectedInvoice: none});
		}
		else {
			return null;
		}
		return (
			<ConfirmReconcilePopup question={question}
								   yesOptionLabel={yesOptionLabel}
								   noOptionLabel={noOptionLabel}
								   yesOptionCallback={yesOptionCallback}
								   noOptionCallback={noOptionCallback}/>
		);
	};

	onReconcile = (invoice: Option<InvoiceSummary>) => this.setState({isLoading: true},
		() => invoice.map(inv => api.instance.transactionApi.reconcileInvoiceTransaction(this.props.transaction.id, inv.id)
			.then(() => {
				this.props.onReconciliationSuccess();
				Toast.success("Transaction reconciled successfully", "Transaction reconciliation");
				getInvoiceById(inv.id).map(invoice => invoice.jobId.map(jId => this.props.fetchInvoice(jId)));
				this.setState({reconciliationSuccess: true, selectedInvoice: invoice, isLoading: false},
					() => {
						this.fetchInvoicePaymentSummmaries();
						this.fetchRecommendations();
					});
			})
			.catch(error => {
				this.setState({isLoading: false});
				notifyBugsnagAndShowToast(error, "Reconcile transaction");
			})
		)
	);

	onUndoReconciliation = (invoiceId: string) => this.setState({isLoading: true},
		() => api.instance.transactionApi.undoReconcileInvoiceTransaction(this.props.transaction.id, invoiceId)
			.then(() => {
				this.props.onReconciliationSuccess();
				Toast.success("Transaction unreconciled successfully", "Undo reconciliation");
				getInvoiceById(invoiceId).map(invoice => invoice.jobId.map(jId => this.props.fetchInvoice(jId)));
				this.setState({
						reconciliationSuccess: false,
						selectedSummary: none,
						selectedInvoice: none,
						showUndoReconciliationConfirm: false,
						isLoading: false
					},
					() => {
						this.fetchInvoicePaymentSummmaries();
						this.fetchRecommendations();
					})
			})
			.catch(error => {
				this.setState({isLoading: false});
				notifyBugsnagAndShowToast(error, "Undo reconciliation")
			}));

	fetchInvoicePaymentSummmaries = () =>
		api.instance.transactionApi.fetchInvoicePaymentSummariesForTransaction(this.props.transaction.id)
			.then((invoicePaymentSummaries) => this.setState({invoicePaymentSummaries}))
			.catch((error) => notifyBugsnagAndShowToast(error, "Fetch invoice payments summary"));
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchInvoice: (jobId: string) => dispatch(
			fetchInvoice(jobId, () => {}, () => {})
		)
	}
}

export default withRouter<IProps>(connect(null, mapDispatchToProps)(ReconciliationModal))
